import React, { useState } from 'react'
import moment from 'moment'
import MomentUtils from '@date-io/moment'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'


const DateField = ({
  name,
  onChange,
  value: valueString,
  ...props
}) => {
  const [value, setValue] = useState(new Date(valueString || Date.now()))
  const handleChange = (date) => {
    setValue(date)

    return onChange({
      target: {
        name,
        value: date ? date.toISOString() : '',
      }
    })
  }

  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
      <KeyboardDatePicker
        margin="normal"
        id="date-picker"
        variant="inline"
        format="MM/DD/YYYY"
        value={value}
        onChange={handleChange}
        {...props}
      />
    </MuiPickersUtilsProvider>
  )
}


DateField.defaultProps = {
  value: '',
  onChange: () => { },
}


export default DateField
